import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col" }
const _hoisted_2 = { class: "px-4 py-3 bg-gray-lp-2800 border-b border-gray-lp-2800" }
const _hoisted_3 = { class: "font-bold text-base text-black-lp-100" }
const _hoisted_4 = { class: "px-4 pt-3 pb-3 flex flex-col gap-2" }
const _hoisted_5 = { class: "inline-flex items-center gap-2 border border-gray-lp-1600 rounded-full pl-2 pr-3 py-1.5 w-fit" }
const _hoisted_6 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-8px px-1 py-0.5"
}
const _hoisted_7 = {
  key: 1,
  class: "bg-red-lp-3100 rounded text-center text-red-lp-2400 font-medium text-8px px-1 py-0.5"
}
const _hoisted_8 = { class: "text-black-lp-100" }
const _hoisted_9 = {
  key: 0,
  class: "w-full flex flex-col gap-2 py-2"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "h-3 bg-gray-lp-1800 rounded animate-pulse w-3/4" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "h-3 bg-gray-lp-1800 rounded animate-pulse w-1/2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "h-3 bg-gray-lp-1800 rounded animate-pulse w-2/3" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "border border-gray-lp-1600 rounded-xl overflow-hidden"
}
const _hoisted_14 = { class: "flex items-center px-4 py-3 bg-gray-lp-2800 border-b border-gray-lp-1600 font-semibold text-black-lp-100" }
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = { class: "w-24 text-right" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { class: "w-24 text-right" }
const _hoisted_19 = { class: "flex items-center px-4 py-3 bg-gray-lp-2800 border-t border-gray-lp-1600 font-semibold text-black-lp-100" }
const _hoisted_20 = { class: "flex-1" }
const _hoisted_21 = { class: "w-24 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock(_component_OverlayPanel, {
    ref: "overlay",
    appendTo: "body",
    class: "saved-package-tooltip",
    style: [{"width":"380px","font-weight":"400"}, {
      backgroundColor: '#ffffff',
      color: '#333333',
    }]
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.tooltip.title")), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.pkg.isQuarantine)
              ? (_openBlock(), _createBlock("span", _hoisted_6, " K "))
              : _createCommentVNode("", true),
            (_ctx.pkg.isDangerousGoods)
              ? (_openBlock(), _createBlock("span", _hoisted_7, " DG "))
              : _createCommentVNode("", true),
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.displayName(_ctx.pkg)), 1)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _hoisted_12
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.tooltip.dimensionHeader")), 1),
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.tooltip.weightHeader")), 1)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailPieces, (piece, idx) => {
                  return (_openBlock(), _createBlock("div", {
                    key: idx,
                    class: "flex items-center px-4 py-2 text-black-lp-100"
                  }, [
                    _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.tooltip.dimensionValue", {
              length: piece.length,
              width: piece.width,
              height: piece.height,
            })), 1),
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.tooltip.weightValue", {
              weight: piece.grossWeight,
            })), 1)
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_19, [
                  _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.tooltip.totalWeight")), 1),
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("bookingV4.goods.savedPackage.tooltip.weightValue", {
              weight: _ctx.totalGrossWeight,
            })), 1)
                ])
              ]))
        ])
      ])
    ]),
    _: 1
  }, 512))
}